import React, { useState } from 'react';
import {
  Wrapper,
  ModalTitle,
  ModalContent,
  Strong,
  Notice,
  Preview,
  Action
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { Modal } from '@app/src/common/Modal';

interface Props {
  configTheme?: any;
  price?: number;
}

export const ExampleModal: React.FC<Props> = ({ configTheme, price }) => {

  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (e:React.SyntheticEvent<HTMLAnchorElement>):void => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleCloseModal = ():void => setShowModal(false);

  return (
    <React.Fragment>
      <Wrapper>
        <Action href='#' onClick={handleOpenModal} color={configTheme && configTheme.color}>
          Ver ejemplo
          <Icon data-name='icon-info' width='14' height='14' fill={configTheme && configTheme.color} />
        </Action>
      </Wrapper>
      <Modal show={showModal} closeModal={handleCloseModal}>
        <ModalTitle>Descripción del aviso</ModalTitle>
        <ModalContent>
          <Strong>Ejemplo</Strong>
          {
            <Preview
              title={configTheme && configTheme.modalExample && configTheme.modalExample.title}
              words={configTheme && configTheme.modalExample && configTheme.modalExample.content}
            />
          }
          <Strong>Nota</Strong>
          <Notice>
            <li>Tu aviso tiene 12 palabras incluidas con 12 caracteres cada una.</li>
            <li>Máximo 20 palabras.</li>
            <li>Puedes contratar extracargos para resaltar de mejor manera tu aviso, cada palabra adicional te cuesta S/{price} soles.</li>
          </Notice>
        </ModalContent>
      </Modal>
    </React.Fragment>
  );
};
